import { NgModule } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AppHeaderComponentModule } from './components/app-header/app-header.module';
import { ClickOutsideDirectiveModule } from './directives/click-outside/click-outside-directive.module';
import { NgxSmartModalModule } from 'ngx-smart-modal';
import { ModalTemplateComponent } from './components/modals/modal-template/modal-template.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DirectivesModule } from './directives/directives.module';
import { OverlayComponent } from './components/overlay/overlay.component';
import { SubscriptionsRemovingComponent } from './components/subscription-removing/subscription-removing.component';
import { ConnectionServiceModule } from 'ng-connection-service';
@NgModule({ 
    exports: [
        AppHeaderComponentModule,
    ], imports: [CommonModule,
        FormsModule,
        AppHeaderComponentModule,
        ClickOutsideDirectiveModule,
        NgxSmartModalModule.forRoot(),
        DirectivesModule,
        ConnectionServiceModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class SharedModule {
  constructor() { }
}
